export default [
  {
    path: '/demo-photo-album',
    component: () => import('@/views/demo/PhotoAlbum1.vue'),
    name: 'PhotoAlbum',
    meta: {
      title: '测试相册图库',
    },
  },
  {
    path: '/demo-storage',
    component: () => import('@/views/demo/Storage.vue'),
    name: 'demo-storage',
    meta: {
      title: '本地数据',
    },
  },
  {
    path: '/demo-lanchApp',
    component: () => import('@/views/demo/LanchApp.vue'),
    name: 'demo-lanchApp',
    meta: {
      title: '唤起APP',
    },
  },
  {
    path: '/demo-longlink',
    component: () => import('@/views/demo/Longlink.vue'),
    name: 'demo-storage',
    meta: {
      title: '长链接',
    },
  },
  {
    path: '/demo-compressImage',
    component: () => import('@/views/demo/CompressImage.vue'),
    name: 'demo-compresssImage',
    meta: {
      title: '压缩图片',
    },
  },
  // 相机相册调试
  {
    path: '/demo-uploadFile',
    component: () => import('../../views/demo/UploadFile.vue'),
    name: 'demo.uploadFile',
    meta: {
      auth: 0,
      visibleShare: true,
      backgroundClass: 'bg-black',
    },
  },
  // 分断折线图
  {
    path: '/demo-breakChart',
    component: () => import('../../views/demo/BreakChart.vue'),
    name: 'demo.breakChart',
    meta: {
      auth: 0,
      visibleShare: true,
      backgroundClass: 'bg-black',
    },
  },
  // 分断折线图
  {
    path: '/demo-trackImage',
    component: () => import('../../views/demo/TrackImage.vue'),
    name: 'demo.trackImage',
    meta: {
      auth: 0,
      visibleShare: true,
      backgroundClass: 'bg-black',
    },
  },
];
